import { FontStyles } from "../../../../utils/font-styles.ts";
import { cn } from "../../../../utils/cn.ts";
import { PropertyTagsDisplay } from "../../../property-tags-display.tsx";
import { PropertyKeyInfoList } from "../../../property-key-info-list.tsx";
import { SectionHeader } from "../../../../components/section-header.tsx";
import { focusStyles } from "../../../../utils/focus-styles.ts";
import "../../../../../assets/fa-icons/css/fontawesome.css";
import "../../../../../assets/fa-icons/css/sharp-regular.css";
import { usePropertyDetailsContext } from "../../../contexts/property-details-context.tsx";
import { BookingButton } from "../../../components/booking-button.tsx";
import { AgentLogoImage } from "../../../../components/agent-logo-image.tsx";

export type AgentContactBarDesktopProps = Record<string, never>;

export const AgentContactBarDesktop = () => {
  const { mainTitle, agentLogoUrl, agentPhone, agentName, agentPageUrl } = usePropertyDetailsContext();

  return (
    <div className="hidden lg:flex flex-col w-[300px] py-4.5 px-6.5 lg:shrink-0 lg:border-l lg:border-foggy-firth bg-neutral-white">
      <div className="flex flex-col flex-1 min-h-0 gap-4 overflow-hidden">
        <PropertyTagsDisplay className="flex flex-wrap gap-1.5" />
        {mainTitle && <SectionHeader text={mainTitle} className={FontStyles.h5} />}
        <PropertyKeyInfoList className="flex flex-col gap-4 overflow-y-auto overflow-x-hidden flex-1" />
      </div>
      <div className="flex flex-col shrink-0">
        <div className="flex flex-col gap-3 ">
          {agentLogoUrl && (
            <div className="border border-foggy-firth rounded-md flex items-center justify-center h-[130px] p-3.5 overflow-hidden">
              <AgentLogoImage
                agentLogoUrl={agentLogoUrl}
                agentName={agentName}
                agentPageUrl={agentPageUrl}
                imgClassName="max-w-full max-h-full object-contain"
              />
            </div>
          )}

          {agentPhone && (
            <p className={cn(FontStyles["body-md"], "tracking-normal text-slate !leading-none text-center")}>
              Call agent:{" "}
              <a href={"tel:" + agentPhone} aria-label={`Call agent on ${agentPhone}`} className={focusStyles}>
                <span className="font-semibold">{agentPhone}</span>
              </a>
            </p>
          )}

          <BookingButton className="w-full" />
        </div>
      </div>
    </div>
  );
};
